import { z } from "zod";

export enum AgentType {
	IATA = "IATA",
	Agent = "Agent",
}

export enum AgentStatus {
	Active = "Active",
	Archived = "Archived",
}

export const AgentTypeOptions = [
	{ value: AgentType.IATA, label: "salesAgents.type.iata" },
	{ value: AgentType.Agent, label: "salesAgents.type.agent" },
];

export const salesAgentFormSchema = z.object({
	agentNumber: z.string().trim().min(1, { error: "val.required" }).max(64),
	type: z.enum(AgentType),
});

export type SalesAgentFormValues = z.infer<typeof salesAgentFormSchema>;

// API DTO — type-only, never parsed at runtime (same convention as the promo
// code DTO). The backend owns id/resellerId/status/timestamps.
export interface SalesAgent {
	id: string;
	agentNumber: string;
	type: AgentType;
	resellerId: string;
	status: AgentStatus;
	createdAt: string;
	updatedAt: string;
}
